import { env } from "@/env";

/** The product's display name — always the Persian word. */
export const BRAND = "گراما";

/** `<scheme>://song/12` for the installed app (desktop/mobile), scheme from NEXT_PUBLIC_APP_SCHEME. */
export const appUri = (path: string) => `${env.NEXT_PUBLIC_APP_SCHEME}://${path.replace(/^\//, "")}`;
